"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModal = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var KeyboardButton_1 = require("./KeyboardButton");
var Modal_1 = require("./Modal");
var Actions = function (props) {
    var formikContext = (0, formik_1.useFormikContext)();
    var _a = props.secondaryAction, secondaryAction = _a === void 0 ? "Cancel" : _a, _b = props.onSecondaryAction, onSecondaryAction = _b === void 0 ? props.hideModal : _b;
    var withSecondaryAction = props.withSecondaryAction || props.withCancel;
    if (!withSecondaryAction && props.hideSubmit)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        withSecondaryAction && (react_1.default.createElement(KeyboardButton_1.KeyboardButton, { variant: "secondary", size: "small", disabled: formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting, shortcut: props.secondaryActionShortcut || "", onClick: function () {
                if (formikContext)
                    formikContext.resetForm();
                onSecondaryAction();
            } }, secondaryAction)),
        !props.hideSubmit && (react_1.default.createElement(KeyboardButton_1.KeyboardButton, { size: "small", loading: formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting, shortcut: props.actionShortcut || "", onClick: function (e) {
                e.stopPropagation();
                if (formikContext)
                    formikContext.submitForm();
                if (props.onAction)
                    props.onAction();
            } }, props.action))));
};
/**
 * Modal component combined with Formik. You *must* wrap this in a Formik provider.
 * @param {Function} hideModal - Required. Function to be called when exiting the modal
 * @param {boolean} isOpen - Required. Describes if the modal should be shown or not
 * @param {string=} title - Title of the modal
 * @param {string=} width - Can be small, medium, or a custom pixel value
 * @param {string=} action - Primary action button text
 * @param {string=} actionShortcut - Primary action hotkey to display
 * @param {Function=} onAction - Primary action handler
 * @param {boolean=} hideSubmit - Hides the primary action button
 * @param {boolean=} withCancel - Shows the secondary action button
 * @param {string=} secondaryAction - Secondary action handler
 * @param {string=} secondaryActionShortcut - Secondary action hotkey to display
 * @param {boolean=} withSecondaryAction - Shows the secondary action button
 * @param {Function=} onSecondaryAction - Secondary action handler
 * @param {boolean=} showIcon - Controls visibility of the close icon
 * @param {string=} maxHeight - Overrides the max scroll container height
 * @param {string=} margin - Overrides the default margin style
 * @param {boolean=} shouldCloseOnOverlayClick - Controls whether the overlay should close the modal
 * @param {boolean=} shouldCloseOnEsc - Controls whether the esc key should close the modal
 * @param {Object=} style - Custom style object used in react-modal
 * @param {Object=} style.content - Custom content styles
 * @param {Object=} style.overlay - Custom overlay styles
 */
var FormModal = function (props) {
    var withSecondaryAction = props.withSecondaryAction || props.withCancel;
    var showActions = withSecondaryAction || !props.hideSubmit;
    return (react_1.default.createElement(Modal_1.Modal, __assign({ actions: showActions ? react_1.default.createElement(Actions, __assign({}, props)) : null }, props)));
};
exports.FormModal = FormModal;
